/* lc-find-form.js — builds the storefront search query for the "Find your list" form.

   Fields: State -> County -> Lead type -> Frequency.

   Product titles read like:
     "Divorce - Rock County, WI - Aug 31-Sep 6, 2026 (2 Records)"   (weekly)
     "Pre-Foreclosures - Shelby County, AL - March 2026"            (monthly)

   So the search terms are built from the lead type, the county name and the state
   ABBREVIATION (the full state name never appears in a title). Frequency has no field
   of its own — it is carried as ?lc_freq= and applied on the results page from the
   date format in the title (see lc-search-frequency.js). */
(function () {
  var LC_STATE_ABBR = {
    'Alabama': 'AL', 'Alaska': 'AK', 'Arizona': 'AZ', 'Arkansas': 'AR', 'California': 'CA',
    'Colorado': 'CO', 'Connecticut': 'CT', 'Delaware': 'DE', 'District of Columbia': 'DC',
    'Florida': 'FL', 'Georgia': 'GA', 'Hawaii': 'HI', 'Idaho': 'ID', 'Illinois': 'IL',
    'Indiana': 'IN', 'Iowa': 'IA', 'Kansas': 'KS', 'Kentucky': 'KY', 'Louisiana': 'LA',
    'Maine': 'ME', 'Maryland': 'MD', 'Massachusetts': 'MA', 'Michigan': 'MI', 'Minnesota': 'MN',
    'Mississippi': 'MS', 'Missouri': 'MO', 'Montana': 'MT', 'Nebraska': 'NE', 'Nevada': 'NV',
    'New Hampshire': 'NH', 'New Jersey': 'NJ', 'New Mexico': 'NM', 'New York': 'NY',
    'North Carolina': 'NC', 'North Dakota': 'ND', 'Ohio': 'OH', 'Oklahoma': 'OK', 'Oregon': 'OR',
    'Pennsylvania': 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC', 'South Dakota': 'SD',
    'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT', 'Vermont': 'VT', 'Virginia': 'VA',
    'Washington': 'WA', 'West Virginia': 'WV', 'Wisconsin': 'WI', 'Wyoming': 'WY'
  };

  function wire(form) {
    if (form.__lcFind) return;
    form.__lcFind = 1;

    form.addEventListener('submit', function () {
      var typeSel = form.querySelector('[data-lc-type]');
      var stateSel = form.querySelector('[data-lc-state]');
      var countySel = form.querySelector('[data-lc-county]');
      var freqSel = form.querySelector('[data-lc-freq]');
      var qInput = form.querySelector('input[name="q"]');
      var freqInput = form.querySelector('[data-lc-freq-param]');

      if (qInput) {
        var parts = [];
        if (typeSel && typeSel.value) parts.push(typeSel.value);
        if (countySel && countySel.value) parts.push(countySel.value);
        if (stateSel && stateSel.value) {
          // Only forms that ask for it search on the abbreviation; other find forms
          // on the site keep searching on the full state name.
          var useAbbr = form.getAttribute('data-lc-state-format') === 'abbr';
          parts.push((useAbbr && LC_STATE_ABBR[stateSel.value]) || stateSel.value);
        }
        qInput.value = parts.join(' ');
      }

      // A disabled input is not submitted, so the param only appears when a
      // frequency is actually chosen.
      if (freqInput) {
        var freq = freqSel ? freqSel.value : '';
        freqInput.value = freq;
        freqInput.disabled = !freq;
      }
    });
  }

  function init() {
    document.querySelectorAll('.lc-find-form').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
